import { stripUnit } from 'polished';
import { useMediaQuery } from 'react-responsive';

import { BreakPoint } from '@makemydeal/dr-activities-common';
import { DESKTOP, MOBILE, TABLET } from '../constants';

type ViewportMode = 'desktop' | 'tablet' | 'mobile';

export const getBreakPointType = (width: number): ViewportMode => {
    const breakpoints = {
        small: stripUnit(BreakPoint.SMALL) as number,
        medium: stripUnit(BreakPoint.MEDIUM) as number
    };
    if (width < breakpoints.small) {
        return MOBILE;
    } else if (width > breakpoints.small && width < breakpoints.medium) {
        return TABLET;
    } else if (width > breakpoints.medium) {
        return DESKTOP;
    }
    return MOBILE;
};

export const ScreenWidth = {
    PHONE: parseInt(BreakPoint.PHONE, 10),
    SMALL: parseInt(BreakPoint.SMALL, 10),
    MEDIUM: parseInt(BreakPoint.MEDIUM, 10),
    LARGE: 1400
} as const;

export type ScreenWidthValue = (typeof ScreenWidth)[keyof typeof ScreenWidth];

export const mediaDown = (width: ScreenWidthValue): string => `(max-width: ${width}px)`;

export const mediaUp = (width: ScreenWidthValue): string => `(min-width: ${width + 1}px)`;

export const useMediaDown = (width: ScreenWidthValue): boolean => useMediaQuery({ query: mediaDown(width) });

export const useMediaUp = (width: ScreenWidthValue): boolean => useMediaQuery({ query: mediaUp(width) });
